import * as React from 'react';
import { CurrencyType } from '../../models/utilities/type-models';
import { Currency } from '../currency/Currency';
import { InputFeedback } from '../form-elements/InputFeedback';

type InputType = 'text' | 'number';

// #region Component Props

interface IProps {
    type            : InputType;
    id              : string;
    value           : any;
    onChange        : any;
    classList       : string;
    error           : string;
    name            : string;
    currencyType    : CurrencyType;
    showSymbol      : boolean;
}

// #endregion

export const EditCurrencyCell = (props: IProps) => {

    const { id, value, onChange, classList, error, currencyType, showSymbol, name  } = props;

    return <td className={'editing-cell ' + classList }>
                <Currency                     
                    id={ id }
                    name={ name }
                    currencyType={ currencyType}
                    showSymbol={ showSymbol }
                    value={ value ? value : '' }
                    onChange={ onChange } />
                {
                    error ? <InputFeedback error={ error } /> : <span/>
                }
            </td>;
};
